import React from 'react';
import { MainHeading, SitemapContent } from '../../components';
import { Container } from 'react-bootstrap';

const Sitemap = () => {
    const sidemapcontent = [
        {
            pageheading: 'About us',
            headinglink: '/aboutus',
            links: [
                {
                    link: '#/',
                    linktext: 'Annual Report',
                    sublinks: [
                        { sublink: '#/', sublinktext: 'Maui Community' },
                        { sublink: '#/', sublinktext: 'Innovation' },
                        { sublink: '#/', sublinktext: 'Future' }
                    ]
                },
                {
                    link: '#/',
                    linktext: 'Community engagement',
                    sublinks: [
                        { sublink: '#/', sublinktext: 'Education and workforce development' },
                        { sublink: '#/', sublinktext: 'Diversity and inclusion' }
                    ]
                }
            ]
        },
        {
            pageheading: 'What we offer',
            headinglink: '#/',
            links: [
                {
                    link: '#/',
                    linktext: 'Insurance products',
                    sublinks: [
                        {
                            sublink: '#/',
                            sublinktext: 'Workers’ compensation',
                            sublinksChild: [
                                { sublinkchild: '#/', sublinkchildtext: 'State workers’ comp programs' },
                                { sublinkchild: '#/', sublinkchildtext: 'Small deductible plans  ' }
                            ]
                        },
                    ]
                },
                {
                    link: '/business-insurance',
                    linktext: 'Business Insurance',
                    sublinks: [
                        { sublink: '/business-insurance/small-business', sublinktext: 'Small Business' },
                        { sublink: '/business-insurance/corporate', sublinktext: 'Corporate' }
                    ]
                }
            ]
        },
        {
            pageheading: 'Contact us',
            headinglink: '#/',
            links: [
                {
                    link: '#/',
                    linktext: 'Annual Report',
                    sublinks: [
                        { sublink: '#/', sublinktext: 'Maui Community' },
                        { sublink: '#/', sublinktext: 'Innovation' },
                        { sublink: '#/', sublinktext: 'Future' }
                    ]
                },
                {
                    link: '#/',
                    linktext: 'Community engagement',
                    sublinks: [
                        { sublink: '#/', sublinktext: 'Education and workforce development' },
                        { sublink: '#/', sublinktext: 'Diversity and inclusion' }
                    ]
                }
            ]
        },
    ];

    return (
        <div className='sitemap-wrapper'>
            <Container>
                <MainHeading title="Sitemap" showshare={false} />
                <SitemapContent data={sidemapcontent} />
            </Container>
        </div>
    );
};

export default Sitemap;
